enum BiteLogCardConnectEvent {
  TerminalDisconnected = 1,
  UpdateIdleTextError = 2,
  /** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
  AuthAndCaptureDeprecated = 7,
}

export { BiteLogCardConnectEvent };
